<template>
  <base-layout :do-skip-header="false">
    <template #main>
      <h1 class='text-3xl md:text-4xl font-bold mt-8'>Sponsors EBM Portugal 2026</h1>

      <!-- <div class="py-6 text-xl font-bold text-red-700">
        This year we will have a maximum of 30 Sponsors/Exhibitors, please contact Mario@TheBrokerSite.com if you are interested in Sponsoring.
      </div> -->

        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          
          <h2 class='text-lg font-bold mt-8 mb-4'>Main Sponsor</h2>

          <div class="-mx-6 grid gap-4 o grid-cols-1 ">
            <a v-if='mainSponsor' href="javascript:void(0)" @click='toSponsorSite(mainSponsor)' class="bg-white shadow-xl shadow-indigo-900/5 pb-4">
              <!-- <div class="float-right pt-2 pr-2 uppercase text-xs text-gray-400">{{mainSponsor.sponsorType}}</div> -->
              <img class="max-h-32 pt-4 w-full object-contain" :src="mainSponsor.logoURL" :alt="mainSponsor.name"/>
            </a>
          </div>
          <h2 class='text-lg font-bold mt-8 mb-4'>Other Sponsors</h2>

          <div class="-mx-6 grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            <a href="javascript:void(0)" 
              @click='toSponsorSite(sponsor)' 
              v-for='sponsor in sponsors' 
              :key='sponsor.name' 
              class="bg-white shadow-xl shadow-indigo-900/5 pb-4"
              :class="{'sm:col-span-2': sponsor.sponsorType.includes('submain')}">
                <img class="max-h-32 pt-4 w-full object-contain" 
                :src="sponsor.logoURL" 
                :alt="sponsor.name"/>
            </a>
          </div>

        </div>

      <div v-if="showSponsorLimit" class="py-12 px-2 text-xl">
        <!-- <strong>Sponsorship Opportunities</strong>

        <br><br>A maximum of <strong>30 sponsor positions</strong> are available for the 22nd European Broker Meeting, ensuring <strong>high visibility and strong exposure</strong> for every participating company.

        <br><br>As shown in the floor plan above, all sponsor booths are located in the main meeting room, surrounding the central Meeting Tables Area, where continuous meetings and networking take place. The layout shows all numbered sponsor positions (1–30).

        <br><br>Booth positions are allocated after payment, based on availability and on a first-come, first-served basis. Sponsors may select an available position from the official meeting room layout.

        <br><br>For sponsorship details and availability, please contact: -->

        <strong>Interested in Sponsoring #EBM2027?</strong>
        <br><br>If you are interested in sponsoring the 23rd European Broker Meeting in Istanbul, Turkey, please email <a href="mailto:mario@thebrokersite.com?Subject=Sponsoring of the EBM 2027 in Istanbul, Turkey" class="underline text-red-700"><strong>Mario@TheBrokerSite.com</strong></a> for more information.
        
      </div>

    </template>
  </base-layout>
</template>

<script>
import _ from "lodash";
import BaseLayout from "../components/BaseLayout.vue";

export default {
  name: "Register",
  components: {
    BaseLayout,
  },
  data() {
    return {
      mainSponsor: null, 
      sponsors: [],
      sponsorLimit: 25,
      showSponsorLimit: true,
      showFullFloorplan: true,
    };
  },
  async created(){
    const sponsors = await this.$http.get("/api/misc/sponsors").then(res => res.data.payload)
    const sponsorDTOs = _.map(sponsors, sponsor => {
      return _.extend({}, sponsor, {
        logoURL: `${window.location.origin}/images/sponsors/${sponsor.logo}`,
        sponsorType: `${sponsor.type} Sponsor`
      })
    })
    this.mainSponsor = _.find(sponsorDTOs, {type: "main"})
    this.sponsors = _.difference(sponsorDTOs, [this.mainSponsor])
  },
  methods: {
    toSponsorSite(sponsor){
      window.open(sponsor.url, "_blank");
    },
    isSubMainSponsor(sponsorType) {
      return sponsorType.includes('submain')
    },
  }
};
</script>

<style>
.special-sponsor img {
  grid-column: span 2;
}
</style>